<div class="saved-filters-wrapper">
  <!-- Trigger button -->
  <button
    type="button"
    class="saved-filters-trigger"
    [class.dashed]="triggerStyle === 'dashed'"
    [class.solid]="triggerStyle === 'solid'"
    [class.activefilter]="activeFilterset !== null"
    (click)="toggle()"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox">
    <div class="trigger-icon">
      <i *ngIf="!activeFilterset" class="bi bi-bookmark"></i
      ><i *ngIf="activeFilterset" class="bi bi-bookmark-fill"></i>
    </div>
    <div class="trigger-label">
      {{ triggerLabel }}
    </div>
    <i
      *ngIf="isDrifted"
      class="bi bi-exclamation-triangle-fill drift-indicator"
      aria-label="Unsaved changes"></i>
    <div class="trigger-chevron" [class.open]="isOpen">
      <i class="bi bi-caret-down-fill"></i>
    </div>
  </button>

  <!-- Dropdown panel -->
  <div
    class="saved-filters-dropdown"
    *ngIf="isOpen"
    role="dialog"
    aria-label="Saved filters">
    <!-- Empty state -->
    <ng-container *ngIf="filtersets.length === 0 && !showSavePanel">
      <div class="empty-state">
        <div class="empty-filters-icon"><i class="bi bi-bookmark"></i></div>
        <p><strong>No saved filters</strong></p>
        <p>
          Save the filters you use most to recall them in one click. Saved
          filters are only visible to you and only apply to this report.
        </p>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="atCap"
          (click)="openSavePanel()">
          + Save current filters
        </button>
        <p class="empty-hint">
          You can also save filter sets from within the Filter modal.
        </p>
      </div>
    </ng-container>

    <!-- Filterset list -->
    <ng-container *ngIf="filtersets.length > 0 && !showSavePanel">
      <ul class="filterset-list" role="listbox">
        <li class="filterset-row filtersets-title">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9">
                <span class="filtersets-title">Your saved filters</span>
              </div>
              <div class="col-3">
                <span class="filtersets-count"
                  >{{ filtersets.length }} saved</span
                >
              </div>
            </div>
          </div>
        </li>
        <li
          *ngFor="let fs of filtersets; trackBy: trackByFiltersetId"
          class="filterset-row"
          [class.activefilter]="activeFilterset?.id === fs.id"
          role="option"
          [attr.aria-selected]="activeFilterset?.id === fs.id">
          <!-- Inline rename -->
          <ng-container *ngIf="renamingRowId === fs.id; else normalRow">
            <input
              class="rename-input form-control"
              type="text"
              [(ngModel)]="renameValue"
              maxlength="60"
              (keydown.enter)="confirmRename(fs.id)"
              (keydown.escape)="cancelRename()"
              autofocus />
            <span class="rename-error" *ngIf="renameError">{{
              renameError
            }}</span>
            <button
              type="button"
              class="btn-icon btn-confirm"
              (click)="confirmRename(fs.id)"
              aria-label="Confirm rename">
              &#10003;
            </button>
            <button
              type="button"
              class="btn-icon btn-cancel me-2"
              (click)="cancelRename()"
              aria-label="Cancel rename">
              &#10005;
            </button>
          </ng-container>

          <ng-template #normalRow>
            <span
              class="filterset-name"
              (click)="applyFilterset(fs)"
              (keydown.enter)="applyFilterset(fs)"
              tabindex="0"
              role="button">
              {{ fs.title }}
            </span>
            <span class="row-actions">
              <!-- Rename icon -->
              <button
                *ngIf="deletingRowId !== fs.id"
                type="button"
                class="btn-icon btn-rename"
                (click)="startRename(fs.id, fs.title ?? '')"
                aria-label="Rename">
                <i class="bi bi-pencil"></i>
              </button>
              <!-- Delete icon / inline confirm -->
              <ng-container *ngIf="deletingRowId === fs.id; else deleteBtn">
                <span class="delete-confirm">
                  <button
                    type="button"
                    class="btn-cancel-delete"
                    (click)="cancelDelete()"
                    autofocus>
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn-confirm-delete"
                    (click)="confirmDelete(fs.id)">
                    Delete
                  </button>
                </span>
              </ng-container>
              <ng-template #deleteBtn>
                <button
                  type="button"
                  class="btn-icon btn-delete me-2"
                  (click)="startDelete(fs.id)"
                  aria-label="Delete">
                  <i class="bi bi-trash"></i>
                </button>
              </ng-template>
            </span>
          </ng-template>
        </li>
      </ul>

      <!-- Footer: save action -->
      <div class="dropdown-footer">
        <button
          type="button"
          class="btn btn-neutral"
          [disabled]="atCap"
          [title]="
            atCap
              ? 'You\'ve reached 50 saved filters. Delete one to save another.'
              : ''
          "
          (click)="openSavePanel()">
          Save as new filter set
        </button>

        <button
          *ngIf="activeFilterset && isDrifted"
          type="button"
          class="btn btn-link"
          [disabled]="isUpdating"
          (click)="updateActiveFilterset()">
          Save filter changes
        </button>
      </div>
    </ng-container>

    <!-- Save panel (inline naming) -->
    <div class="save-panel" *ngIf="showSavePanel">
      <label class="form-label" for="new-filterset-name">Filter set name</label>
      <input
        id="new-filterset-name"
        class="form-control"
        type="text"
        [(ngModel)]="newFiltersetName"
        maxlength="60"
        placeholder="e.g. Weekly coaching review"
        (keydown.enter)="saveCurrentFilters()"
        (keydown.escape)="cancelSavePanel()"
        autofocus />
      <span class="save-error" *ngIf="nameValidationError">{{
        nameValidationError
      }}</span>
      <div class="save-actions">
        <button
          type="button"
          class="btn btn-cancel"
          (click)="cancelSavePanel()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="isSaving"
          (click)="saveCurrentFilters()">
          Save
        </button>
      </div>
    </div>
  </div>
</div>
